import React from 'react'
import PropTypes from 'prop-types'
import { AuthProvider } from 'react-oidc-context'

const ZitadelProviderWithHistory = ({ children }) => {
  const issuer = process.env.REACT_APP_ZITADEL_ISSUER || 'http://localhost:8081'
  const clientId = process.env.REACT_APP_ZITADEL_CLIENT_ID || ''
  const redirectUri = process.env.REACT_APP_ZITADEL_REDIRECT_URI || window.location.origin

  const config = {
    authority: issuer,
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid profile email',
    onSigninCallback: (user) => {
      // Extract returnTo from appState (encoded by Dashboard.login)
      let returnHash = '/dashboard'
      try {
        const appStateJSON = user?.state?.appStateJSON
        if (appStateJSON && typeof appStateJSON === 'string') {
          const parsed = JSON.parse(decodeURIComponent(appStateJSON))
          if (parsed && typeof parsed.returnTo === 'string') {
            // returnTo is like "/#/dashboard"; extract the hash path
            returnHash = parsed.returnTo.replace(/^[^#]*#/, '') || '/dashboard'
          }
        }
      } catch (e) {
        console.warn('[ZitadelProvider] Failed to parse appState:', e)
      }
      // Clean up OIDC query params, then navigate via hash so HashRouter fires
      window.history.replaceState({}, document.title, window.location.pathname)
      window.location.hash = returnHash
    },
  }

  return <AuthProvider {...config}>{children}</AuthProvider>
}

ZitadelProviderWithHistory.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ZitadelProviderWithHistory
